package org.example.project.settings

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

fun lumaticaCheckboxGlyph(checked: Boolean): String = if (checked) "\u2705" else "\u2B1C"

@Composable
fun LumaticaCheckboxSymbol(checked: Boolean, fontSizePx: Int = 20) {
    Span({ style { fontSize(fontSizePx.px); lineHeight("1"); property("user-select", "none") } }) {
        Text(lumaticaCheckboxGlyph(checked))
    }
}

/**
 * Einheitliche Checkbox für das gesamte Lumatica-System.
 * Zeigt ✅ (gecheckt) oder ⬜ (ungecheckt).
 * Konsistent mit dem TabularScreen Toggle-Verhalten.
 *
 * Verwendung:
 *   LumaticaCheckbox(checked = isActive, onChange = { isActive = it })
 *   LumaticaCheckbox(checked = isActive, onChange = { isActive = it }, enabled = false)
 */
@Composable
fun LumaticaCheckbox(
    checked: Boolean,
    onChange: (Boolean) -> Unit,
    enabled: Boolean = true,
    fontSizePx: Int = 20
) {
    Span({
        style {
            fontSize(fontSizePx.px)
            cursor(if (enabled) "pointer" else "default")
            property("user-select", "none")
            property("opacity", if (enabled) "1" else "0.35")
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
        }
        if (enabled) onClick {
            it.stopPropagation()
            onChange(!checked)
        }
    }) {
        LumaticaCheckboxSymbol(checked, fontSizePx)
    }
}

